const zh = {
  check_out_with_prefix: '用',
  check_out_with_suffix: '支付',

  Enter_Card_Number_Manually: '手动输入卡号',
  payment_method_title: '支付方式',
  add_your_card_here_title: '添加信用卡',
  change_payment_method_title: '更改支付方式',
  confirm_and_pay_button: `确认并支付 • \${paymentAmount}`,
  confirm_and_pay_button_no_card: `添加支付方式 • \${paymentAmount}`,
  add_new_card: '添加新卡',
  cancel_button: '取消',
  done_button: '确认',
  balance_amount: '余额: ${paymentAmount}'
}

export default zh
